export const accessKeys = {
  // The signed-in person's roles and rules (GET /v2/access/me), keyed by who is
  // signed in so one person's cached rules are never read for another.
  me: (authUserId: string | null) =>
    ['v2', 'access', 'me', authUserId] as const,
}
